/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Ash!",
  title: "Hi all, I'm Ash!",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 specializing in PHP, Laravel, React, and Vue.js development with expert-level API integration skills for building robust web applications and seamless backend-frontend solutions."
  ),
  extra: emoji(
    "🚀 Entrepreneur of Hello Deer! - a convenience store with Chevron gas station in Alberta. When not coding, I'm managing the store or playing guitar 🎸 for creative inspiration."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1E5MTbJnCYTEI1Q7Lt43I9knuehWK7Hzk/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ashesthetic",
  linkedin: "https://www.linkedin.com/in/bappi-d-great/",
  gmail: "aknath.707@gmail.com",
  facebook: "https://www.facebook.com/bappi.d.great/",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Full-stack development with Node.js, React, and Vue.js, specializing in REST API development and WordPress customization"
    ),
    emoji(
      "⚡ Expert integration of AI-powered tools (ChatGPT, GitHub Copilot, Cursor, etc) to enhance code quality and accelerate development cycles"
    ),
    emoji(
      "⚡ Proven ability to troubleshoot complex issues, improve legacy codebases, and work effectively with Git, Asana, and Jira"
    ),
    emoji(
      "⚡ Skilled in predictive analysis, intelligent debugging, and smart feature recommendations through AI-driven solutions"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "ai",
      fontAwesomeClassname: "fas fa-brain"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "IBAIS University",
      logo: require("./assets/images/ibais.png"),
      subHeader: "Bachelor of Science in Computer Science & Engineering",
      duration: "July 2007 - June 2011",
      desc: "Graduated with a Bachelor's degree in Computer Science & Engineering from IBAIS University, Dhaka, Bangladesh.",
      descBullets: [
        "Completed a comprehensive curriculum in Computer Science & Engineering, covering core subjects like Data Structures, Algorithms, Operating Systems, and Computer Networks.",
        "Gained hands-on experience in software development, web applications, and system programming through various projects and assignments."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend/PHP-Laravel", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "React/Vue.js",
      progressPercentage: "70%"
    },
    {
      Stack: "REST API",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    },
    {
      Stack: "Frontend Design",
      progressPercentage: "60%"
    },
    {
      Stack: "WordPress",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
        role: "Full Stack Developer",
        company: "Optinmonster (Awesome Motive)",
        companylogo: require("./assets/images/om.png"),
        date: "February 2020 – August 2025",
        desc: "Developed and maintained Optinmonster, a SaaS-based platform for creating and managing optin forms, along with its WordPress plugin integration.",
        descBullets: [
          "Huge experience of working on REST API to connect tens of ESPs (Email Service Providers)",
          "Developed and maintained the core Optinmonster SaaS platform for creating and managing optin forms",
          "Built and maintained the WordPress plugin that integrates with the Optinmonster SaaS platform"
        ]
    },
          {
        role: "Junior Developer",
        company: "WPMU DEV (Incsub LLC)",
        companylogo: require("./assets/images/wpmu.png"),
        date: "September 2013 – January 2020",
        desc: "Played a multifaceted role bridging development, support, and quality assurance. Responsible for improving product functionality, guiding third-party integrations, and ensuring smooth user experience from development to post-launch.",
        descBullets: [
          "Guided development of third-party products and services integration",
          "Added new features to existing projects and completed bug fixes for product releases",
          "Developed and maintained new functionality within key products",
          "Assisted in QA process before and after product launches",
        ]
      },
          {
        role: "SharePoint Frontend Developer",
        company: "WM Reply",
        companylogo: require("./assets/images/wm.jpg"),
        date: "June 2011 – August 2013",
        desc: "Supported development, maintenance, and updates of web portals and websites. Created front-end architecture and implemented solutions according to client requirements using various programming tools and techniques.",
        descBullets: [
          "Supported development, maintaining, and updating web portals as well as websites",
          "Assisted in the deployment and development of websites",
          "Created the front-end architecture and implemented it",
          "Planned, wrote, and tested codes for web-based solutions"
        ]
      }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME COMPANIES THAT I HELPED TO GROW WITH NEW MODULES, FEATURES, AND TECHNICAL IMPROVEMENTS",
  projects: [
    {
      image: require("./assets/images/om.png"),
      projectName: "OptinMonster",
      projectDesc: "A SaaS-based platform for creating and managing optin forms",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://optinmonster.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/tp.png"),
      projectName: "TrustPulse",
      projectDesc: "A Social Proof and Fomo App for Marketers",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://trustpulse.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1-368-999-1284",
  email_address: "aknath.707@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
